export default __webpack_public_path__ + "static/media/firebase.65c4fe9f.png";